import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useState } from "react";
import { Divider } from "@mui/material";
import { PrimaryButton } from "styles/jss/Layout.styles";
import {
  AccordionItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "styles/jss/Accordions.styles";
import NextImage from "./NextImage";
import { formatDate, isEmpty } from "utils/helperFunction";

export default function Accordions({ certificates }) {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const [expanded, setExpanded] = useState(false);

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      {certificates.map(item => {
        const { content, title, date, image, url, id } = item;

        return (
          <AccordionItem
            key={id}
            active={expanded === id ? "active" : ""}
            className={"accordionItem"}
          >
            <Divider orientation="vertical" className={"vertical-line"} />
            <Accordion expanded={expanded === id} onChange={handleChange(id)}>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <span className={"date"}>
                  {formatDate(
                    date,
                    locale === "fa" ? "jYYYY/jMM/jDD" : "MM/DD/YYYY",
                    locale,
                  )}
                </span>
                <h4 className={"title"}>{title}</h4>
              </AccordionSummary>
              <AccordionDetails hasimage={!isEmpty(image.data) ? "yes" : "no"}>
                <div className={"contentWrapper"}>
                  <div className={"contentTextWrapper"}>
                    <p className={"content"}> {content}</p>
                    {Boolean(url) && (
                      <PrimaryButton>
                        <a href={url}>{t("history.reedMore")}</a>
                      </PrimaryButton>
                    )}
                  </div>
                  {!isEmpty(image.data) && (
                    <NextImage
                      src={image.data.attributes.formats.medium.url}
                      leyout={"responsive"}
                      width={161}
                      height={225}
                    />
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          </AccordionItem>
        );
      })}
    </>
  );
}
